import { getTenantSubdomainFromHostname } from "~/utils/public-store-host"
import { useOfflinePosConnectivity } from "~/composables/useOfflinePosConnectivity"

export default defineNuxtRouteMiddleware(async (to) => {
	if (process.server) return

	const config = useRuntimeConfig()
	const baseDomain = String(config.public.baseDomain || "").toLowerCase()
	const hostname = String(window.location.hostname || "").toLowerCase()
	const subdomain = getTenantSubdomainFromHostname(hostname, baseDomain, {
		appSubdomain: config.public.appSubdomain,
		reservedSubdomains: config.public.reservedSubdomains,
	})
	const isSubdomainHost = Boolean(subdomain)

	if (isSubdomainHost) return

	const { data: auth, status, getSession } = useAuth()
	const online = useOfflinePosConnectivity()
	if (!online.value) {
		const branchId = localStorage.getItem("sv_pos_branch_id")
		const posId = localStorage.getItem("sv_pos_device_id")
		if (branchId && posId) {
			const { getOfflineSnapshot } = await import("~/utils/offline-pos")
			const snapshot = await getOfflineSnapshot(branchId, posId).catch(() => null)
			if (snapshot?.auth?._id && snapshot?.shift?.opening_time && !snapshot?.shift?.closing_time) return
		}
	}

	if (status.value === "loading" && typeof getSession === "function") {
		await getSession()
	}

	if (!auth.value) {
		return await navigateTo("/login")
	}
})
